
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { addInquirySheet } from "@/api/inquiry";
import {
  getAppendix,
  changeUpload,
  uploadInfoFile,
  deleteShippingMarks,
  deleteInfo,
} from "@/api/proforma";
import { doDownload, doDownloadPDF } from "@/utils/oss-download";

@Component({
  name: "file-management",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "文件管理" }) private title: "";
  @Prop({ default: {} }) private selectedItem: {} | any;

  @Watch("show", { immediate: true })
  private async watchData() {
    if (this.show) {
      this.getAppendix();
    }
  }

  private form = {
    customerId: null,
    company: null,
  };
  public info = {} as any;
  public infoFields = [
    {
      label: "采购订单号",
      key: "poCode",
    },
    {
      label: "供应商简称",
      key: "supplierAbbreviation",
    },
    {
      label: "采购员",
      key: "purchase",
    },
    {
      label: "销售员",
      key: "seller",
    },
  ] as any;
  public tableCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      show: true,
      disabled: false,
    },
    {
      label: "文件名",
      prop: "description",
      key: "description",
      show: true,
      disabled: false,
    },
    {
      label: "上传时间",
      prop: "uploadTime",
      key: "uploadTime",
      show: true,
      disabled: false,
    },
    {
      label: "上传用户",
      prop: "uploader",
      key: "uploader",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        { name: "下载", code: "", click: "handleDownload" },
        { name: "替换", code: "", click: "handleChange", type: "upload" },
      ],
      show: true,
      disabled: false,
      width: 160,
    },
  ] as any;

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }
  public loading: Boolean = false;
  // 获取附件
  private async getAppendix() {
    this.loading = true;
    this.info = await getAppendix(this.selectedItem.id, {
      receipt: false,
    });
    this.info.appendixList.forEach((item, index) => {
      item.sn = index + 1;
    });
    this.loading = false;
  }

  private handleDownload(scope: any) {
    const url = scope?.row?.ossUrl;
    if (!url) {
      this.$notify.error("文件地址为空");
      return;
    }
    const name = String(scope?.row?.description || "");
    const isPdf = /\.pdf(\?|#|$)/i.test(String(url)) || /\.pdf$/i.test(name);
    if (isPdf) {
      doDownloadPDF(url, name || undefined);
      return;
    }
    doDownload(url);
  }

  // 替换
  private async handleChange(val) {
    const { file, item } = val;
    let formData = new FormData();
    formData.append("id", item.id);
    formData.append("receipt", "false");
    formData.append("file", file.file);
    await changeUpload(item.id, formData);
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getAppendix();
  }

  // 上传
  private async handleUpload(file) {
    let formData = new FormData();
    formData.append("poId", this.selectedItem.id);
    formData.append("receipt", "false");
    formData.append("files", file.file);
    await uploadInfoFile(formData);
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getAppendix();
  }

  private async handleDelete() {
    if (!this.selectedRows.length) {
      this.$notify.error("请选择要删除的数据");
      return;
    }
    const ids = this.selectedRows.map((item) => item.id);
    const params = ids.map((id) => `ids=${id}`).join("&");
    this.$confirm("确定删除吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await deleteInfo(params);
        this.$notify({
          title: "成功",
          message: "删除成功",
          type: "success",
          duration: 2000,
        });
        (this.$refs.table as any).$refs.table.clearSelection();
        this.getAppendix();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  // 新建询价单
  private async addInquirySheet() {
    const { customerId, company } = this.form;
    let params = {
      customerId,
      company,
    };
    try {
      await addInquirySheet(params);
      this.$notify({
        title: "成功",
        message: "创建成功",
        type: "success",
        duration: 2000,
      });
      this.close();
      this.$emit("success", false);
    } catch {}
  }

  private selectedRows: any[] = [];

  private onSelectionChange(rows: any[]) {
    this.selectedRows = rows;
  }
}
